import { Row, Col, Breadcrumb } from "react-bootstrap";

const BreadCrumbs = () => (
  <Row>
    <Col xs="12">
      <Breadcrumb className="leap">
        <Breadcrumb.Item active>LEAP Online Home</Breadcrumb.Item>
      </Breadcrumb>
    </Col>
  </Row>
);

export default BreadCrumbs;
